import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=581a09ca&"
import script from "./MessageList.vue?vue&type=script&lang=js&"
export * from "./MessageList.vue?vue&type=script&lang=js&"
import style0 from "./MessageList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports